var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menuList.length > 0)?_c('div',{staticClass:"ivu-shrinkable-menu"},[_vm._t("top"),_vm._v(" "),_c('sidebar-menu',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shrink),expression:"!shrink"}],attrs:{"menu-theme":_vm.theme,"menu-list":_vm.menuList,"open-names":_vm.openNames,"iconSize":22},on:{"on-change":_vm.handleChange}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }